import { createReducer, on } from '@ngrx/store';
import * as WorkTypesActions from './work-types.actions';
import { initialWorkTypesState } from './work-types.state';

export const workTypesReducer = createReducer(
  initialWorkTypesState,

  on(WorkTypesActions.loadWorkTypes, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(WorkTypesActions.loadWorkTypesSuccess, (state, { workTypes, pagination }) => ({
    ...state,
    workTypes,
    loading: false,
    error: null,
    pagination,
  })),

  on(WorkTypesActions.loadWorkTypesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(WorkTypesActions.createWorkType, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(WorkTypesActions.createWorkTypeSuccess, (state, { workType }) => ({
    ...state,
    workTypes: [ ...state.workTypes, workType ],
    loading: false,
    error: null,
  })),

  on(WorkTypesActions.createWorkTypeFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(WorkTypesActions.updateWorkType, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(WorkTypesActions.updateWorkTypeSuccess, (state, { workType }) => ({
    ...state,
    workTypes: state.workTypes.map(wt => wt.id === workType.id ? workType : wt),
    loading: false,
    error: null,
  })),

  on(WorkTypesActions.updateWorkTypeFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(WorkTypesActions.deleteWorkType, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(WorkTypesActions.deleteWorkTypeSuccess, (state, { id }) => ({
    ...state,
    workTypes: state.workTypes.filter(wt => wt.id !== id),
    loading: false,
    error: null,
  })),

  on(WorkTypesActions.deleteWorkTypeFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);
